import { Share } from '@promoboxx/graphql-gateway-types'
import { useHistory } from 'react-router'

export type ShareDialogEvent =
  | 'shareDialogOpened'
  | 'shareDialogClosed'
  | 'shareDialogUpdated'
  | 'shareDialogDeleted'
export type ShareDialogEventData = {
  id: Share['id']
  channel: Share['channel']
}

export function buildShareDialogHref(
  id: Share['id'],
  channel: Share['channel'],
) {
  if (!channel) {
    throw new Error('channel is required')
  }
  const params = new URLSearchParams(window.location.search)
  params.set('editShareId', id)
  params.set('editShareType', channel) // why? shouldn't an id be unique enough for the endpoint? its not really a problem but it feels clunky
  params.delete('shareSettingId')
  params.delete('shareSettingBrandId')
  return `${window.location.pathname}?${params.toString()}`
}

export function useShareDialog() {
  const history = useHistory()

  function subscribe(eventName: ShareDialogEvent, cb: () => void) {
    document.addEventListener(eventName, cb)
  }

  function unsubscribe(eventName: ShareDialogEvent, cb: () => void) {
    document.removeEventListener(eventName, cb)
  }

  function publish(eventName: ShareDialogEvent, data?: ShareDialogEventData) {
    const event = new CustomEvent(eventName, { detail: data })
    document.dispatchEvent(event)
  }

  function openShareDialog(id: Share['id'], channel: Share['channel']) {
    const url = buildShareDialogHref(id, channel)
    history.push(url)
    publish('shareDialogOpened', { id, channel })
  }

  function closeShareDialog() {
    const params = new URLSearchParams(window.location.search)

    const editShareId = params.get('editShareId') || ''
    const editShareType = params.get('editShareType')

    params.delete('editShareId')
    params.delete('editShareType')

    history.push(`${window.location.pathname}?${params.toString()}`)

    publish('shareDialogClosed', { id: editShareId, channel: editShareType })
  }

  return {
    closeShareDialog,
    openShareDialog,
    subscribe,
    unsubscribe,
    publish,
  }
}
